import {
  FC,
  forwardRef,
  Fragment,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { Accordion } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { arrayMoveImmutable } from "array-move";
import { DropResult } from "react-beautiful-dnd";
import moment, { Moment } from "moment";
import { DatePicker, Popover, Progress } from "antd";
import { Button } from "elements";

import {
  Wrapper,
  Head,
  Col,
  WeightContent,
  NameContent,
  NameWrapper,
  AddActionItemBtn,
  Toggle,
  CollapseWrapper,
  Body,
  ActionButton,
  ProgressContainer,
} from "./styled";

import { DraggableItem, NewItem } from "../Item";
import InputWrapper from "../InputWrapper";
import { DeleteItemModal } from "../DeleteItemModal";

import EditIcon from "../../../../assets/svg/edit.svg";
import TrashIcon from "../../../../assets/svg/trash.svg";

import upIcon from "./up.svg";
import disableArrow from "./disableArrow.svg";
import addIcon from "./add.svg";

import { ReactComponent as CalanderIcon } from "./calander.svg";
import { ReactComponent as CloseIcon } from "assets/svg/closeCricle.svg";

// @ts-ignore
import {
  changeActionItemsOrder,
  createActionItem,
  updatePlanCategory,
  updateCategoryState,
  // @ts-ignore
} from "modules/actions/PlanActions";

// @ts-ignore
import RoundedProgress from "../../PlanHeader/components/RoundProgress";

import { ICategory, IItem } from "../@types";

// @ts-ignore
import classes from "./styled.module.scss";
// @ts-ignore

// @ts-ignore
import {
  getTime,
  useUser,
  // @ts-ignore
} from "utils/utility";
import {
  ValidateCategoryStartLineValue,
  ValidateCatrgoryDeadLineValue,
} from "../../../../utils/validateValue";
import ErrorTooltip from "../../../../components/ErrorTooltip";
import { isColumnVisible } from "../../../../utils/helper";

// import ValidateValue from "../../../../utils";
// @ts-ignore
import ManageCustomMetricsModal from "../../Modal/ManageCustomMetrics";
import SelectMetric from "./SelectMetric";
import { LoadingOutlined } from "@ant-design/icons";
import { ProgressWrapper, StatusIconWrapper } from "../Item/styled";
import { statusOptions } from "../../../ProjectPlanner/components/GoalSettings/data";
import { successToast, undoToast } from "../../../../utils/toast";
import CustomSwitch from "../../../../components/CustomSwitch";
import { FrozenWrapper, UnFrozenWrapper } from "../styled";
import { allowedKeys, controlKeys } from "../../../ProjectPlanner/components/GoalSettings/utils";

interface IProps {
  data?: ICategory;
  additionalData?: {
    plan_start_date: string | null;
    plan_end_date: string | null;
    plan_owner?: any;
  };
  isActive?: boolean;
  isNew?: boolean;
  isShared: boolean;
  onToggle?: (id: string) => void;
  onCreate?: (value: string) => void;
  onAdjustWeight?: () => void;
  isExpandAllNotes?: boolean;
  provided?: any;
  isAddCategory?: boolean;
  setIsAddCategory?: (value: boolean) => void;
  mainContainer?: any;
  PlanDetails?: any;
  filterBy?: any;
  isNewCategoryLoading?: boolean;
  checkedItems?: any;
  setCheckedItems?: any;
  customizeColumns?: any;
}

interface IAddProps {
  isShared: boolean;
  onCreate: (value: string) => void;
  setIsAddCategory: (value: boolean) => void;
  isNewCategoryLoading: boolean;
}

type ActionItem = {
  plan_progress: number;
  status?: number;
};

interface IHandle {
  focusInput: () => void;
}

export const AddCategory: FC<IAddProps> = ({
  isShared,
  onCreate,
  setIsAddCategory,
  isNewCategoryLoading,
}) => {
  const $categoryRef = useRef<IHandle>(null);

  useEffect(() => {
    $categoryRef.current?.focusInput();
  }, []);

  return (
    <Category
      isNew
      isShared={isShared}
      onCreate={onCreate}
      ref={$categoryRef}
      setIsAddCategory={setIsAddCategory}
      isNewCategoryLoading={isNewCategoryLoading}
    />
  );
};

const Category = forwardRef<IHandle, IProps>(
  (
    {
      data,
      additionalData,
      isActive,
      isNew,
      isShared,
      onToggle,
      onCreate,
      onAdjustWeight,
      isExpandAllNotes,
      provided,
      setIsAddCategory,
      isAddCategory,
      PlanDetails,
      mainContainer,
      filterBy,
      checkedItems,
      setCheckedItems,
      isNewCategoryLoading,
      customizeColumns,
    },
    ref
  ) => {
    const {
      id,
      name,
      duration,
      weight,
      plan_progress,
      category_progress,
      project_plan,
      start_line,
      dead_line,
      start,
      current,
      target,
      action_items,
      label,
      metric_unit_name,
      custom_unit_name,
      is_active,
      metric_label,
      custom_unit,
      metric_unit,
    } = data || ({} as ICategory);

    const nameCategory = name;

    const dispatch = useDispatch();

    const { planDetails, isUnActiveCategories } = useSelector(
      (state: any) => state.plan.plan
    );

    const [isEditItemText, setIsEditItemText] = useState(false);
    const [isErrorName, setIsErrorName] = useState(false);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [isAdd, setIsAdd] = useState(false);
    const [selectedValue, setSelectedValue] = useState<any>();
    const [selectedUnit, setSelectedUnit] = useState<string | null>();
    const [measurementPop, setMeasurementPop] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [IsAddMetric, setIsAddMetric] = useState(false);
    const [categoryName, setCategoryName] = useState("");
    const [defaultName, setDefaultName] = useState(nameCategory);
    const [isProgressLoading, setIsProgressLoading] = useState(false);
    const [isCategoryActive, setIsCategoryActive] = useState(true);
    const [measureLoading, setMeasureLoading] = useState(false);

    const $nameRef = useRef<IHandle>(null);
    const $newItemRef = useRef<IHandle>(null);
    const newItemRef = useRef<HTMLDivElement>(null);

    const user = useUser();
    const onwerEmail = PlanDetails?.invited_owner;
    const userEmail = user?.email;
    const isOnwer = onwerEmail === userEmail;
    const isActionItems =
      planDetails?.categories
        ?.map((category: any) => category?.action_items)
        ?.flat()?.length > 0;

    const isCategoryItems =
      action_items?.map((category: any) => category?.action_items)?.flat()
        ?.length > 0;

    const [values, setValues] = useState({
      start: start || null,
      current: current || null,
      target: target || null,
    });

    useImperativeHandle(ref, () => ({
      focusInput: () => {
        if ($nameRef.current) {
          $nameRef.current.focusInput();
        }
      },
    }));

    const onClickHandle = () => {
      if (onToggle) onToggle(id.toString());
    };

    const onDragEndHandle = (result: DropResult) => {
      if (!result.destination) {
        return;
      }

      const oldIndex = result.source.index;
      const newIndex = result.destination.index;

      if (oldIndex !== newIndex) {
        const newData = arrayMoveImmutable(
          action_items.slice(),
          oldIndex,
          newIndex
        );

        const actions: Pick<IItem, "id" | "order_id">[] = [];

        newData?.forEach((element, index) => {
          if (element) {
            actions?.push({
              id: element?.id,
              order_id: index,
            });
          }
        });

        const payload = {
          category: id,
          actions,
        };

        dispatch(changeActionItemsOrder(payload, project_plan));
      }
    };

    const handleCreateActionItem = (value: string) => {
      const payload = {
        name: value,
        start_line: moment(start_line ?? new Date()).format("YYYY-MM-DD"),
        dead_line: moment(dead_line ?? new Date()).format("YYYY-MM-DD"),
        project_plan: project_plan,
        category: id,
      };

      dispatch(createActionItem(payload));
      setIsAdd(false);
    };

    const onError = () => {
      setCategoryName(defaultName);
      setDefaultName(defaultName);
      setIsErrorName(true);
    };

    const handleNameChange = (value: string, name: string) => {
      if (isNew) {
        onCreate?.("");
        return;
      }

      if (!value) return;

      if (value !== defaultName) {
        dispatch(
          updatePlanCategory(
            id,
            { project_plan, [name]: value },
            true,
            handleCloseAction,
            onError
          )
        );
      }
    };

    const handleSaveCategoryName = () => {
      if (!categoryName) return;

      if (isNew) {
        onCreate?.(categoryName);

        return;
      }
      setCategoryName("");
    };

    const handleUndo = () => {
      dispatch(
        updatePlanCategory(id, { project_plan, name: defaultName }, true)
      );
    };

    const handleCloseAction = () => {
      undoToast("Category name updated successfully", "Success!", handleUndo);
    };

    const handleAddActionItem = () => {
      setIsAdd(true);
      setIsAddCategory && setIsAddCategory(false);

      if (newItemRef?.current && mainContainer?.current) {
        const itemPosition =
          newItemRef.current.getBoundingClientRect().top +
          newItemRef.current.scrollHeight;
        const containerPosition =
          mainContainer.current.getBoundingClientRect().top;

        setTimeout(() => {
          mainContainer.current.scrollTo({
            top:
              itemPosition -
              containerPosition +
              mainContainer.current.scrollTop,
            behavior: "smooth",
          });
        }, 500);
      }

      if (!isActive) {
        onToggle && onToggle(id.toString());
      }

      if ($newItemRef && $newItemRef.current) {
        if (onToggle && !isActive) {
          onToggle(id.toString());

          setTimeout(() => {
            $newItemRef.current?.focusInput();
          }, 500);
        } else {
          $newItemRef.current?.focusInput();
        }
      }
    };

    const isDateDisabled = (
      current: Moment,
      name: "start_line" | "dead_line"
    ): boolean => {
      if (!current) return false;

      if (name === "start_line") {
        if (
          additionalData?.plan_start_date &&
          current.isBefore(moment(additionalData.plan_start_date), "day")
        ) {
          return true;
        }
        if (
          additionalData?.plan_end_date &&
          current.isAfter(moment(additionalData.plan_end_date), "day")
        ) {
          return true;
        }
      } else if (name === "dead_line") {
        if (
          additionalData?.plan_start_date &&
          current.isBefore(moment(additionalData.plan_start_date), "day")
        ) {
          return true;
        }
        if (
          additionalData?.plan_end_date &&
          current.isAfter(moment(additionalData.plan_end_date), "day")
        ) {
          return true;
        }
        if (start_line && current.isBefore(moment(start_line), "day")) {
          return true;
        }
      }

      return false;
    };

    const startPlanDate = additionalData?.plan_start_date || null;
    const endPlanDate = additionalData?.plan_end_date || null;

    const startLineError = ValidateCategoryStartLineValue(
      start_line,
      startPlanDate,
      endPlanDate
    );
    const deadLineError = ValidateCatrgoryDeadLineValue(
      dead_line,
      startPlanDate,
      endPlanDate,
      start_line
    );

    const getStatus = (items: ActionItem[], isCount: boolean): any => {
      if (items?.every((item) => item.plan_progress === 0)) {
        return isCount ? 0 : "To Do";
      }
      const completedCount = items?.filter(
        (item) =>
          item.plan_progress === 10 && item?.status !== 5 && item?.status !== 3
      ).length;

      if (isCount) {
        return completedCount;
      }

      if (completedCount === items.length) {
        return "Completed";
      }

      if (
        items?.some((item) => item.plan_progress > 0 && item.plan_progress < 10)
      ) {
        return "In Progress";
      }

      return "Unknown";
    };

    const completedCount = getStatus(action_items || [], true);

    const isCancel =
      action_items?.length > 0
        ? action_items?.every((item: any) => item.status === 5)
        : false;

    const isHold =
      action_items?.length > 0
        ? action_items?.every((item: any) => item.status === 3)
        : false;

    const isAnyHold =
      action_items?.length > 0
        ? action_items?.some((item: any) => item.status === 3)
        : false;

    const isAnyInProgress =
      action_items?.length > 0
        ? action_items?.some((item: any) => item.status === 2)
        : false;

    const isAnyTodo =
      action_items?.length > 0
        ? action_items?.some((item: any) => item.status === 1)
        : false;

    const planProgress =
      plan_progress != null
        ? Number((Number(plan_progress) * 100).toFixed(2))
        : 0;

    const isAnyCompleted =
      action_items?.length > 0
        ? action_items?.some((item: any) => item.status === 4)
        : false;

    useEffect(() => {
      if (!data) return;
      setValues({
        start: start || null,
        current: current || null,
        target: target || null,
      });

      const findUnActiveCategory = isUnActiveCategories?.find(
        (state: any) => state.id === id
      );

      const updatedState =
        findUnActiveCategory === undefined
          ? is_active
          : Boolean(findUnActiveCategory?.isUnActive);

      setIsCategoryActive(updatedState || false);
    }, [data]);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      const target = e.target as HTMLInputElement;
      const currentValue = target.value;

      if (e.key === "-" && currentValue.length > 0) {
        e.preventDefault();
      }

      if (e.key === "0" && currentValue === "-") {
        e.preventDefault();
      }

      if (!allowedKeys.includes(e.key) && !controlKeys.includes(e.key)) {
        e.preventDefault();
      }

      if (e.key === "." || e.key === "+") {
        e.preventDefault();
      }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = e.target;
      if (
        value === "" ||
        value === "-" ||
        /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/.test(value)
      ) {
        setValues((prev) => ({
          ...prev,
          [name]: value === "" ? null : value,
        }));
      }
    };

    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
      const { name, value } = e.target;

      if (value && typeof value === "string" && value.endsWith(".00")) {
        const cleanValue = value.replace(".00", "");
        setValues((prev) => ({
          ...prev,
          [name]: cleanValue,
        }));
      }
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      const { name, value } = e.target;

      if (value && !isNaN(Number(value))) {
        const formattedValue = Number(value).toFixed(2);
        setValues((prev) => ({
          ...prev,
          [name]: formattedValue,
        }));
      }
    };

    const handleUpdateMeasurement = () => {
      setMeasureLoading(true);
      const unitKey = selectedValue.isCustom ? "custom_unit" : "metric_unit";
      let payload = {
        start: Number(values.start).toFixed(2),
        current: Number(values.current).toFixed(2),
        target: Number(values.target).toFixed(2),
        [unitKey]: selectedValue?.unitId,
      };

      if (selectedValue?.isCustom) {
        payload = {
          ...payload,
          label: "custom",
        };
      } else {
        payload = {
          ...payload,
          label: "",
        };
      }

      dispatch(
        updatePlanCategory(id, payload, true, () => {
          successToast("Measurement updated successfully");
          setMeasurementPop(false);
          setMeasureLoading(false);
        })
      );
    };

    const isUnitChanged =
      selectedValue !== undefined
        ? label === "custom"
          ? selectedValue?.unitId === custom_unit
          : selectedValue?.unitId === metric_unit
        : true;

    const disableSaveButton = !isUnitChanged
      ? !values?.start || !values?.current || !values?.target || false
      : !selectedValue ||
        selectedValue?.length === 0 ||
        !values?.start ||
        !values?.current ||
        !values?.target ||
        ((values.start === start ||
          (values.start && start && `${values.start}.00` === start)) &&
          (values.current === current ||
            (values.current &&
              current &&
              `${values.current}.00` === current)) &&
          (values.target === target ||
            (values.target && target && `${values.target}.00` === target)));

    useEffect(() => {
      setValues({
        start: start || null,
        current: current || null,
        target: target || null,
      });

      if (metric_unit_name || custom_unit_name) {
        const findCustomLabel =
          planDetails?.goal?.custom_labels?.length > 0 &&
          planDetails?.goal?.custom_labels
            ?.map((label: any) => {
              const customUnit = label?.custom_unit_options?.find(
                (option: any) => option.id === custom_unit
              );

              if (customUnit) {
                return {
                  label: customUnit?.value,
                  customUnit: customUnit?.id,
                };
              }
              return null;
            })
            ?.filter(Boolean);

        setSelectedUnit(
          label === "custom" ? findCustomLabel?.[0]?.label : metric_unit_name
        );

        setSelectedValue({
          label:
            label === "custom" ? findCustomLabel?.[0]?.label : metric_unit_name,
          unit:
            label === "custom" ? findCustomLabel?.[0]?.customUnit : metric_unit,
          unitId:
            label === "custom" ? findCustomLabel?.[0]?.customUnit : metric_unit,
        });
      }
    }, [measurementPop, metric_unit_name, custom_unit_name]);

    useEffect(() => {
      if (isAddCategory) {
        setIsAdd(false);
      }
    }, [isAddCategory]);

    useEffect(() => {
      setDefaultName(nameCategory);
    }, [nameCategory]);

    const isWeight = isColumnVisible(customizeColumns, "weight");
    const isPlanProgress = isColumnVisible(customizeColumns, "plan_progress");
    const isStatus = isColumnVisible(customizeColumns, "status");
    const isMeasurement = isColumnVisible(customizeColumns, "measurement");
    const isStartLine = isColumnVisible(customizeColumns, "start_date");
    const isEndLine = isColumnVisible(customizeColumns, "due_date");
    const isDuration = isColumnVisible(customizeColumns, "duration");
    const isAssignee = isColumnVisible(customizeColumns, "assignee");

    const handleAddMetric = () => {
      setModalOpen(true);
      setMeasurementPop(false);
    };

    const filteredItems = action_items?.filter((item: any) => {
      const itemProgress = item.plan_progress === null ? 0 : item.plan_progress;

      // Make sure we handle null/undefined filterBy values safely
      const filterByStatus = filterBy?.status || [];
      const filterByWeight = filterBy?.weight || [];
      const filterByProgress = filterBy?.progress || [];
      const filterByWeeklyDuration = filterBy?.weeklyDuration || [];
      const filterByAssignedTo = filterBy?.assignedTo || [];

      return (
        (filterByStatus.length === 0 || filterByStatus.includes(item.status)) &&
        (filterByWeight.length === 0 || filterByWeight.includes(item.weight)) &&
        (filterByProgress.length === 0 ||
          filterByProgress.includes(itemProgress)) &&
        (filterBy?.startDate === null ||
          new Date(item.start_line) >= new Date(filterBy.startDate)) &&
        (filterBy?.dueDate === null ||
          new Date(item.dead_line) <= new Date(filterBy.dueDate)) &&
        (filterByWeeklyDuration.length === 0 ||
          filterByWeeklyDuration.includes(item.duration)) &&
        (filterByAssignedTo.length === 0 ||
          filterByAssignedTo.some(
            (assignee: any) =>
              item.responsible_person?.email === assignee.label ||
              item.responsible_person?.id === assignee
          ))
      );
    });

    const getStatusInfo = () => {
      if (isCancel) {
        return statusOptions[4];
      }

      if (isAnyInProgress) {
        return statusOptions[1];
      }

      if (isAnyTodo) {
        return statusOptions[0];
      }

      if (isHold || (isAnyHold && !isAnyCompleted)) {
        return statusOptions[2];
      }

      if (planProgress === 0) {
        return statusOptions[0];
      } else if (planProgress < 100) {
        return statusOptions[1];
      } else if (planProgress === 100) {
        return statusOptions[3];
      } else {
        return statusOptions[2];
      }
    };

    const StatusInfo = getStatusInfo();

    const handleStateChange = () => {
      const previous = isCategoryActive;
      const newState = !previous;

      setIsCategoryActive(newState);

      dispatch({
        type: "IS_CATEGORY_STATE_UNACTIVE",
        payload: {
          id: id,
          isUnActive: newState,
        },
      });

      if (previous) {
        setCheckedItems?.(
          (
            prev: {
              [key: number]: {
                category: boolean;
                items: { [key: number]: boolean };
              };
            } = {}
          ) => {
            const { [id]: _removed, ...rest } = prev;
            return rest;
          }
        );
      }

      // Make API call
      try {
        const payload = {
          is_active: newState,
        };

        dispatch(updateCategoryState(id, payload, true));
      } catch (error) {
        console.error("Failed to update category state:", error);

        // Revert both local and Redux state on error
        setIsCategoryActive(previous);
        dispatch({
          type: "IS_CATEGORY_STATE_UNACTIVE",
          payload: {
            id: id,
            isUnActive: previous,
          },
        });
      }
    };

    const FrozenHeadItem = () => (
      <>
        <Col $type="small" $active={isCategoryActive} $isCheckbox>
          <input
            style={{
              cursor:
                isShared || isNew || !isActionItems || !isCategoryItems
                  ? "not-allowed"
                  : isCategoryActive
                  ? "pointer"
                  : "default",
              opacity:
                isShared || isNew || !isActionItems || !isCategoryItems
                  ? 0.5
                  : 1,
            }}
            type="checkbox"
            disabled={
              !isCategoryActive ||
              isShared ||
              isNew ||
              !isActionItems ||
              !isCategoryItems ||
              action_items?.length === 0
            }
            checked={
              !isCategoryItems
                ? false
                : checkedItems?.[id]?.category &&
                  action_items?.every(
                    (item: any) => checkedItems?.[id]?.items?.[item.id]
                  )
            }
            value={checkedItems?.[id]?.category || false}
            onChange={(e) => {
              if (
                isShared ||
                isNew ||
                !isActionItems ||
                !isCategoryItems ||
                action_items?.length === 0
              ) {
                return;
              } else {
                const isChecked = e.target.checked;

                setCheckedItems?.((prev: any) => ({
                  ...prev,
                  [id]: {
                    category: isChecked,
                    items: Object.fromEntries(
                      (action_items ?? []).map((item: any) => [
                        item.id,
                        isChecked,
                      ])
                    ),
                  },
                }));
              }
            }}
            ref={(input) => {
              if (
                !isActionItems ||
                !isCategoryItems ||
                action_items?.length === 0
              )
                return;
              if (input) {
                input.indeterminate =
                  action_items?.some(
                    (item: any) => checkedItems?.[id]?.items?.[item.id]
                  ) &&
                  !action_items?.every(
                    (item: any) => checkedItems?.[id]?.items?.[item.id]
                  );
              }
            }}
          />
        </Col>

        <Col $type="small" $active={isCategoryActive}>
          <Toggle
            $active={isActive}
            $isNew={isNew}
            title={isActive ? "Collapse category" : "Expand category"}
            data-testid="expand-collapse-button"
            style={{
              cursor: isShared || isNew ? "not-allowed" : "pointer",
            }}
          >
            {isNew ? (
              <img
                src={disableArrow}
                alt=""
                onClick={onClickHandle}
                style={{
                  cursor: isShared || isNew ? "not-allowed" : "pointer",
                }}
              />
            ) : (
              <img
                src={upIcon}
                alt=""
                onClick={onClickHandle}
                style={{
                  cursor: isShared || isNew ? "not-allowed" : "pointer",
                }}
              />
            )}
          </Toggle>
        </Col>

        <Col $type="large" $active={isCategoryActive}>
          <NameContent
            $disabled={isShared || !isCategoryActive}
            $active={isCategoryActive}
          >
            <NameWrapper
              style={{
                maxWidth: isNew ? "unset" : "200px",
              }}
            >
              <InputWrapper
                name="name"
                defaultValue={defaultName || ""}
                placeholder="Category name"
                disabled={isShared || !isCategoryActive}
                onChange={handleNameChange}
                setInputValue={setCategoryName}
                ref={$nameRef}
                data-testid="category-input"
                textCenter={false}
                maxWordLength={255}
                isEditItemText={isEditItemText}
                setIsEditItemText={setIsEditItemText}
                notEditOnText={true}
                setIsErrorName={setIsErrorName}
                isBlur={isNew ? false : true}
                isErrorName={isErrorName}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSaveCategoryName();
                  }

                  if (e.key === "Escape") {
                    setIsEditItemText(false);
                    setIsAddCategory && setIsAddCategory(false);
                  }
                }}
              />

              {isNew && (
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    size="md"
                    styleType="secondary"
                    style={{
                      whiteSpace: "nowrap",
                    }}
                    onClick={(e: any) => {
                      e.stopPropagation();
                      setIsAddCategory && setIsAddCategory(false);
                    }}
                    onMouseDown={(e: any) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setIsAddCategory && setIsAddCategory(false);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    size="md"
                    style={{
                      whiteSpace: "nowrap",
                    }}
                    onClick={(e: any) => {
                      e.stopPropagation();
                      handleSaveCategoryName();
                    }}
                    onMouseDown={(e: any) => {
                      e.stopPropagation();
                      handleSaveCategoryName();
                    }}
                    disabled={
                      (isNew && (!categoryName || categoryName === "")) ||
                      isNewCategoryLoading
                    }
                  >
                    {isNewCategoryLoading ? <LoadingOutlined /> : "Save"}
                  </Button>
                </div>
              )}
            </NameWrapper>
            {isNew ? null : (
              <ProgressContainer>
                <RoundedProgress
                  size={16}
                  progress={
                    (action_items?.length ?? 0) > 0
                      ? (completedCount / action_items.length) * 100
                      : 0
                  }
                  strokeWidth={2}
                  innerStrokeWidth={2}
                  circleTwoStroke="#1271A6"
                  circleOneStroke="#D0E3ED"
                  fill="transparent"
                />
                <span
                  style={{
                    cursor: "default",
                  }}
                >
                  {completedCount}/{action_items?.length}
                </span>
              </ProgressContainer>
            )}
            {isNew ? null : (
              <ActionButton className="items-actions">
                {!isShared && (
                  <AddActionItemBtn
                    onClick={handleAddActionItem}
                    disabled={isShared || !isCategoryActive}
                    data-testid="add-item-button"
                    style={{
                      opacity: isAdd ? 0.5 : 1,
                      pointerEvents: isAdd ? "none" : "auto",
                      cursor: isAdd ? "not-allowed" : "pointer",
                    }}
                  >
                    <img src={addIcon} alt="" />
                    Add Action Item
                  </AddActionItemBtn>
                )}

                {isShared ? null : (
                  <>
                    <img
                      src={EditIcon}
                      alt=""
                      style={{
                        cursor: isCategoryActive ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!isCategoryActive) return;
                        setIsEditItemText(true);
                      }}
                    />

                    <img
                      src={TrashIcon}
                      alt=""
                      style={{
                        cursor: isCategoryActive ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!isCategoryActive) return;
                        setIsDeleteModalVisible(true);
                      }}
                    />
                  </>
                )}

                <DeleteItemModal
                  itemId={id}
                  itemName={name ?? ""}
                  planId={project_plan}
                  isVisible={isDeleteModalVisible}
                  checkedItems={checkedItems}
                  setCheckedItems={setCheckedItems}
                  type="category"
                  onClose={() => {
                    setIsDeleteModalVisible(false);
                  }}
                />
              </ActionButton>
            )}
          </NameContent>
        </Col>
      </>
    );

    const UnFrozenHeadItem = ({
      column,
      isFrozen,
      key,
    }: {
      column: any;
      isFrozen?: boolean;
      key: string;
    }) => {
      if (!column || column.key === "action_items") return null;

      // Always render visible columns regardless of freeze state to maintain alignment
      if (!column.isVisible) return null;

      if (key === "weight") {
        return (
          isWeight && (
            <Col $active={isCategoryActive} $type="medium">
              {isNew ? null : (
                <WeightContent
                  style={{
                    cursor: isCategoryActive ? "pointer" : "default",
                  }}
                  onClick={isCategoryActive ? onAdjustWeight : undefined}
                  disabled={isShared}
                  title="Adjust weight..."
                  data-testid="weight-category-button"
                >
                  {(Number(weight) * 100).toFixed(2)}%
                </WeightContent>
              )}
            </Col>
          )
        );
      }

      if (key === "plan_progress") {
        return (
          isPlanProgress && (
            <Col
              $active={isCategoryActive}
              $type="medium"
              data-testid="plan-progress-value"
            >
              {isNew ? null : (
                <ProgressWrapper>
                  <Progress
                    percent={
                      plan_progress
                        ? Number((Number(plan_progress) * 100).toFixed(2))
                        : 0
                    }
                    strokeColor={StatusInfo?.color || "#32A6F9"}
                    showInfo={false}
                    width={54}
                  />

                  <span
                    style={{
                      color: StatusInfo?.color || "#32A6F9",
                      cursor: "default",
                    }}
                  >
                    {plan_progress
                      ? Number((Number(plan_progress) * 10).toFixed(1))
                      : 0}
                    /10
                  </span>
                </ProgressWrapper>
              )}{" "}
              {isProgressLoading && isPlanProgress && (
                <LoadingOutlined
                  style={{
                    marginLeft: "5px",
                    fontSize: "12px",
                    color: "#8f8f90",
                  }}
                  spin
                />
              )}
            </Col>
          )
        );
      }

      if (key === "status") {
        return (
          <Col $active={isCategoryActive} $type="medium">
            {isNew
              ? null
              : isStatus && (
                  <StatusIconWrapper
                    style={{
                      cursor: "default",
                    }}
                  >
                    {StatusInfo?.circleIcon && <StatusInfo.circleIcon />}
                    <span>{StatusInfo?.label}</span>
                  </StatusIconWrapper>
                )}
          </Col>
        );
      }

      if (key === "measurement") {
        return (
          <Col $active={isCategoryActive} $type="medium">
            {isNew
              ? null
              : isMeasurement && (
                  <Popover
                    content={
                      <div className="measurement-popover">
                        <div className="measurement-popover-items">
                          <div>
                            <div className="measurement-popover-item">
                              <label>Metric</label>

                              <SelectMetric
                                onAddMetric={handleAddMetric}
                                selectedValue={selectedValue}
                                setSelectedValue={setSelectedValue}
                                selectedUnit={selectedUnit}
                                setSelectedUnit={setSelectedUnit}
                                setIsAddMetric={setIsAddMetric}
                              />
                            </div>
                          </div>
                          <div className="measurement-popover-item">
                            <label>Start</label>
                            <input
                              name="start"
                              type="text"
                              value={values?.start || ""}
                              placeholder="0"
                              disabled={isShared || !selectedValue}
                              onFocus={handleFocus}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              onKeyDown={handleKeyDown}
                              style={{ width: "50px" }}
                            />
                          </div>

                          <div className="measurement-popover-item">
                            <label>Current</label>
                            <input
                              name="current"
                              type="text"
                              value={values?.current || ""}
                              placeholder="0"
                              disabled={isShared || !selectedValue}
                              onFocus={handleFocus}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              onKeyDown={handleKeyDown}
                              style={{ width: "50px" }}
                            />
                          </div>

                          <div className="measurement-popover-item">
                            <label>Target</label>

                            <input
                              name="target"
                              type="text"
                              value={values?.target || ""}
                              placeholder="0"
                              disabled={isShared || !selectedValue}
                              onFocus={handleFocus}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              onKeyDown={handleKeyDown}
                              style={{ width: "50px" }}
                            />
                          </div>
                        </div>

                        <div className="measurement-popover-actions">
                          <button
                            onClick={() => {
                              setMeasurementPop(false);
                              setSelectedUnit("");
                              setMeasureLoading(false);
                              setValues({
                                start: start || null,
                                current: current || null,
                                target: target || null,
                              });
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            onClick={handleUpdateMeasurement}
                            disabled={
                              isShared || disableSaveButton || measureLoading
                            }
                          >
                            {measureLoading ? <LoadingOutlined /> : "Save"}
                          </button>
                        </div>
                      </div>
                    }
                    trigger="click"
                    placement="top"
                    overlayClassName="measurement-popover-overlay"
                    open={
                      isShared || !isCategoryActive ? false : measurementPop
                    }
                    onOpenChange={(value) => {
                      setMeasurementPop(value);
                    }}
                    getPopupContainer={(triggerNode) =>
                      triggerNode.closest(".category-container") as HTMLElement
                    }
                  >
                    <div
                      style={{
                        cursor: isCategoryActive ? "pointer" : "default",
                      }}
                    >
                      {current || "--"}
                    </div>
                  </Popover>
                )}
          </Col>
        );
      }

      if (key === "start_date") {
        return (
          isStartLine && (
            <Col $active={isCategoryActive} $type="medium">
              <div className={classes.datePicker_wrapper}>
                {isNew ? null : isShared ? (
                  start_line ? (
                    moment(start_line).format("YYYY-MM-DD")
                  ) : null
                ) : (
                  <DatePicker
                    className={`${classes.datepicker} ${
                      isCategoryActive
                        ? classes.cursorPointer
                        : classes.cursorDefault
                    }`}
                    // @ts-ignore
                    getPopupContainer={(trigger) =>
                      trigger.closest(".category-container") || document.body
                    }
                    suffixIcon={<CalanderIcon />}
                    format="MMM D"
                    disabledDate={(current) =>
                      isDateDisabled(current, "start_line")
                    }
                    allowClear={false}
                    value={start_line ? moment(start_line) : null}
                    defaultPickerValue={
                      start_line
                        ? moment(start_line)
                        : moment(planDetails?.start_line || new Date())
                    }
                    disabled={isShared || !isOnwer || !isCategoryActive}
                    inputReadOnly
                    onChange={(date, value) => {
                      if (date) {
                        const formattedDate = date.format("YYYY-MM-DD");
                        dispatch(
                          updatePlanCategory(
                            id,
                            {
                              start_line: value ? formattedDate : null,
                            },
                            true,
                            () => {
                              successToast("Start date updated successfully");
                            }
                          )
                        );
                      } else {
                        dispatch(
                          updatePlanCategory(
                            id,
                            {
                              start_line: null,
                            },
                            true,
                            () => {
                              successToast("Start date updated successfully");
                            }
                          )
                        );
                      }
                    }}
                    data-testid="start-category-date"
                  />
                )}

                {startLineError && !isShared && (
                  <ErrorTooltip
                    title={startLineError || ""}
                    isDate={!start_line}
                  />
                )}

                {start_line && !isShared && (
                  <div className={classes.closeIcon}>
                    <CloseIcon
                      style={{
                        opacity: isCategoryActive ? 1 : 0,
                        visibility: isCategoryActive ? "visible" : "hidden",
                        cursor: isCategoryActive ? "pointer" : "default",
                      }}
                      onClick={() => {
                        if (isOnwer && isCategoryActive) {
                          dispatch(
                            updatePlanCategory(
                              id,
                              {
                                start_line: null,
                              },
                              true,
                              () => {
                                successToast("Start date updated successfully");
                              }
                            )
                          );
                        }
                      }}
                    />
                  </div>
                )}
              </div>
            </Col>
          )
        );
      }

      if (key === "due_date") {
        return (
          isEndLine && (
            <Col $active={isCategoryActive} $type="medium">
              <div className={classes.datePicker_wrapper}>
                {isNew ? null : isShared ? (
                  dead_line ? (
                    moment(dead_line).format("YYYY-MM-DD")
                  ) : null
                ) : (
                  <DatePicker
                    className={`${classes.datepicker} ${
                      isCategoryActive
                        ? classes.cursorPointer
                        : classes.cursorDefault
                    }`}
                    // @ts-ignore
                    getPopupContainer={(trigger) =>
                      trigger.closest(".category-container") || document.body
                    }
                    format="MMM D"
                    suffixIcon={<CalanderIcon />}
                    disabledDate={(current) =>
                      isDateDisabled(current, "dead_line")
                    }
                    allowClear={false}
                    value={dead_line ? moment(dead_line) : null}
                    defaultPickerValue={
                      dead_line
                        ? moment(dead_line)
                        : moment(planDetails?.dead_line || new Date())
                    }
                    disabled={isShared || !isOnwer || !isCategoryActive}
                    inputReadOnly
                    onChange={(date, value) => {
                      if (date) {
                        const formattedDate = date.format("YYYY-MM-DD");
                        dispatch(
                          updatePlanCategory(
                            id,
                            {
                              dead_line: date ? formattedDate : null,
                            },
                            true,
                            () => {
                              successToast("Due date updated successfully");
                            }
                          )
                        );
                      } else {
                        dispatch(
                          updatePlanCategory(
                            id,
                            {
                              dead_line: null,
                            },
                            true,
                            () => {
                              successToast("Due date updated successfully");
                            }
                          )
                        );
                      }
                    }}
                    data-testid="end-category-date"
                  />
                )}

                {deadLineError && !isShared && (
                  <ErrorTooltip
                    title={deadLineError || ""}
                    isDate={!dead_line}
                  />
                )}

                {dead_line && !isShared && (
                  <div className={classes.closeIcon}>
                    <CloseIcon
                      style={{
                        opacity: isCategoryActive ? 1 : 0,
                        visibility: isCategoryActive ? "visible" : "hidden",
                        cursor: isCategoryActive ? "pointer" : "default",
                      }}
                      onClick={() => {
                        if (isOnwer && isCategoryActive) {
                          dispatch(
                            updatePlanCategory(
                              id,
                              {
                                dead_line: null,
                              },
                              true,
                              () => {
                                successToast("Due date updated successfully");
                              }
                            )
                          );
                        }
                      }}
                    />
                  </div>
                )}
              </div>
            </Col>
          )
        );
      }

      if (key === "duration") {
        return (
          <Col
            data-testid="duration-category-value"
            $active={isCategoryActive}
            $type="medium"
            style={{
              cursor: "default",
            }}
          >
            {isNew ? null : isDuration && (duration ? getTime(duration) : "")}
          </Col>
        );
      }

      if (key === "assignee") {
        return (
          <Col
            $type="medium"
            $active={isCategoryActive}
            style={{
              cursor: "default",
            }}
          >
            {isNew ? null : "--"}
          </Col>
        );
      }
    };

    return (
      <div ref={newItemRef}>
        <Wrapper
          $color="#1C8B7E"
          className="category-container"
        >
          <Head>
            {!isNew &&
              (customizeColumns || []).some((col: any) => col.isFrozen) && (
                <FrozenWrapper>
                  {FrozenHeadItem()}

                  {(customizeColumns || [])
                    .filter((column: any) => column.isFrozen)
                    .map((column: any) => (
                      <Fragment key={column.key}>
                        {UnFrozenHeadItem({
                          column,
                          key: column.key,
                          isFrozen: true,
                        })}
                      </Fragment>
                    ))}
                </FrozenWrapper>
              )}

            <UnFrozenWrapper>
              {!(customizeColumns || []).some((col: any) => col.isFrozen) &&
                FrozenHeadItem()}

              {(customizeColumns || [])
                .filter((column: any) => column.isVisible && !column.isFrozen)
                .map((column: any) => (
                  <Fragment key={column.key}>
                    {UnFrozenHeadItem({
                      column,
                      key: column.key,
                      isFrozen: false,
                    })}
                  </Fragment>
                ))}

              <Col $active={isCategoryActive} $type="medium">
                {isNew ? null : (
                  <CustomSwitch
                    checked={isCategoryActive}
                    onChange={handleStateChange}
                    disabled={isShared}
                  />
                )}
              </Col>

              <Col $active={isCategoryActive} $type="small"></Col>
            </UnFrozenWrapper>
          </Head>

          {isNew ? null : (
            <div
              ref={provided?.innerRef}
              {...provided?.droppableProps}
              style={{ minHeight: 1 }}
            >
              <Accordion.Collapse as={CollapseWrapper} eventKey={id.toString()}>
                <>
                  <Body>
                    {filteredItems?.map((item, i) => (
                      <DraggableItem
                        PlanDetails={PlanDetails}
                        data={item}
                        additionalData={{
                          plan_start_date: planDetails?.start_line || null,
                          plan_end_date: planDetails?.dead_line || null,
                          category_start_date: start_line,
                          category_end_date: dead_line,
                        }}
                        checkedItems={checkedItems}
                        setCheckedItems={setCheckedItems}
                        categoryId={id}
                        customizeColumns={customizeColumns}
                        isExpand={isExpandAllNotes}
                        projectPlanId={project_plan}
                        isShared={isShared}
                        index={i}
                        setIsProgressLoading={setIsProgressLoading}
                        key={item.id}
                        isCategoryActive={isCategoryActive}
                      />
                    ))}
                    {provided.placeholder}
                  </Body>

                  {isShared
                    ? null
                    : isAdd && (
                        <NewItem
                          isAdd={isAdd}
                          setIsAdd={setIsAdd}
                          projectPlanId={project_plan}
                          ref={$newItemRef}
                          onCreate={handleCreateActionItem}
                        />
                      )}
                </>
              </Accordion.Collapse>
            </div>
          )}

          <ManageCustomMetricsModal
            IsAddMetric={IsAddMetric}
            setIsAddMetric={setIsAddMetric}
            visible={modalOpen}
            setModalOpen={setModalOpen}
            goalId={planDetails?.goal?.id}
            project_plan={project_plan}
          />
        </Wrapper>
      </div>
    );
  }
);

export default Category;
